<template>
  <l-table
    ref="LTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
    table-title="Recommended scientific topics"
  >
    <template #cell(region)="{ data }">
      {{ $langName(data.value) }}
    </template>
  </l-table>

</template>

<script>

import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import scientificTopics from '@/store/scientific-topics/index'
import LTable from '@/views/components/LTable.vue'

export default {
  components: {
    LTable,
  },
  props: {
    regionId: {
      type: Number,
      default: null,
    },
  },
  created() {
    this.$store.commit(`${this.MODULE_NAME}/FRESH`)
  },
  methods: {
    refetchData() {
      this.$refs.LTable.refetchData()
    },
  },
  setup() {
    const MODULE_NAME = 'scientificTopics'

    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, scientificTopics)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })
    const tableColumns = [
      { key: 'index', label: '#', thStyle: { width: '80px' } },
      { key: 'name', label: 'name', sortable: true },
    ]
    return {
      MODULE_NAME,
      tableColumns,
    }
  },
}
</script>

<style lang="scss">
</style>
